function getSavePostingState(state) {
  return state.savePosting;
}

function getTypePublished(state) {
  return { postingPublished: state.step4Module3.postingPublished };
}

export { getSavePostingState, getTypePublished };
